import HamburgerIcon from './HamburgerIcon';
import ChevronLeftIcon from './ChevronLeftIcon';
import { getKeyHandler } from 't-lib-ui/structure';
import './PageHeader.css';

interface PageHeaderProps {
  title: React.ReactNode;
  onMenu?: () => void;
  /** When set, a back arrow is shown before the title. */
  onBack?: () => void;
  rightContent?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, onMenu, onBack, rightContent }) => (
  <div className="pageHeader">
    <div
      className="pageHeaderLeft"
      onClick={() => {
        if (onMenu && typeof window != 'undefined' && window.matchMedia('(max-width: 1240px)').matches)
          onMenu();
      }}
    >
      {onBack && (
        <button
          className="pageHeaderBack flowFocussable"
          tabIndex={0}
          title="Back"
          onClick={e => { e.stopPropagation(); onBack(); }}
          onKeyDown={getKeyHandler(() => onBack())}
        >
          <ChevronLeftIcon size={22} />
        </button>
      )}
      {onMenu && (
        <button
          type="button"
          className="pageHeaderHamburger menuOnMobile flowFocussable"
          tabIndex={0}
          aria-label="Open menu"
          title="Menu"
          onClick={e => { e.stopPropagation(); onMenu(); }}
          onKeyDown={getKeyHandler(() => onMenu())}
        >
          <HamburgerIcon size={24} />
        </button>
      )}
      <h2>{title}</h2>
    </div>
    {rightContent && <div className="pageHeaderRight">{rightContent}</div>}
  </div>
);

export default PageHeader;
